"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("../../utils");
var Card_1 = __importDefault(require("../Card"));
var renderer_1 = require("@react-pdf/renderer");
var calculations_1 = require("../../utils/calculations");
var TotalCbdCard = function (_a) {
    var cannabinoidsPanelResult = _a.cannabinoidsPanelResult, moistureContentPercentage = _a.moistureContentPercentage, density = _a.density, parameters = _a.parameters;
    var totalCBD = calculations_1.deriveTotalCBD(cannabinoidsPanelResult, moistureContentPercentage, density, parameters);
    return (React.createElement(Card_1.default, { style: { alignItems: "center", width: 110 } },
        React.createElement(renderer_1.Text, { style: {
                fontFamily: "Quicksand",
                fontWeight: 700,
                color: "#AD84B5",
            } }, "Total CBD"),
        React.createElement(renderer_1.Text, { style: {
                fontFamily: "Quicksand",
                fontWeight: 700,
            } }, (function () {
            if (typeof totalCBD === "string")
                return totalCBD;
            if (totalCBD <= 0)
                return "ND";
            return utils_1.displayMeasurmentAsPercent(totalCBD);
        })())));
};
exports.default = TotalCbdCard;
//# sourceMappingURL=index.js.map